<template>
	<div class="toast mb-3 fade" v-bind:class="{show: isVisible}" role="alert" aria-live="assertive" aria-atomic="true">
		<div class="toast-header bg-info text-white">
			<i class="mr-2" data-feather="info" style="width: 1.25rem; height: 1.25rem;"></i>
			<span class="font-weight-semibold mr-auto">Добавлено в сравнения!</span>
			<button class="close text-white ml-2 mb-1" type="button" data-dismiss="toast" aria-label="Close"><span aria-hidden="true">&times;</span></button>
		</div>
		<div class="toast-body">Товар <b>&laquo;{{lastAddedName}}&raquo;</b> добавлен в таблицу сравнения.</div>
	</div>
</template>

<script>
	import { bus } from "Util/bus.js";

	const sleepTime = 5000;

	export default {
		name: "add-comparison",
		data() {
			return {
				isVisible: false,
				lastAddedName: ""
			}
		},
		methods: {
			sleep(ms) {
				return new Promise(resolve => setTimeout(resolve, ms));
			},
			comparisonAdded(value) {
				this.isVisible = true;
				this.lastAddedName = value;

				this.sleep(sleepTime).then(() => {
					this.isVisible = false;
				});
			}
		},
		created() {
			bus.$on("comparisonAdded", this.comparisonAdded);
		}
	}
</script>